import { a as allCountries, c as countrySearchAliases } from '../constants/countryLists-Ck89Ck3L.js';

/* eslint-disable id-length */
const searchCountries = (countries, searchValue) => {
  const regex = new RegExp(searchValue, 'i'); // ignore case
  return countries.filter(([countryName, countryCode]) => {
    if (!countryName) return false;

    // check if other alises exist for the country
    const countryNames = [countryName, ...countrySearchAliases[countryCode]];

    // return true if any alias matches
    if (countryNames.some(name => regex.test(name))) {
      return true;
    }
    return false;
  }).map(([, countryCode]) => countryCode);
};
const useSearchCountries = ({
  countries,
  exclude,
  labels,
  match
}) => {
  let searchedCountries = allCountries;
  if (countries || exclude) {
    const allowedCountries = [];
    for (let i = 0; i < allCountries.length; i++) {
      let shouldAllow = true;
      const country = searchedCountries[i];
      if (countries && !countries.includes(country)) {
        shouldAllow = false;
      }
      if (exclude && exclude.length) {
        if (exclude.includes(country)) {
          shouldAllow = false;
        }
      }
      if (shouldAllow) {
        allowedCountries.push(country);
      }
    }
    searchedCountries = allowedCountries;
  }
  if (match && labels) {
    return searchCountries(Object.entries(labels).filter(([name, code]) => searchedCountries.includes(code)), match);
  }
  return searchedCountries;
};

export { useSearchCountries as u };
//# sourceMappingURL=useSearchCountries-Ejwakgcv.js.map
